// Create or patch this file — use ONE app instance for auth & storage
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY!,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET!, // e.g. xxx.appspot.com
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID!,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Export ONE shared instances
export const auth = getAuth(app);
export const storage = getStorage(app);

// Small diag once per load (helps verify you're on the right project/bucket)
if (typeof window !== 'undefined') {
  // @ts-ignore
  console.log('[BR] Firebase project:', app.options?.projectId, 'bucket:', firebaseConfig.storageBucket);
}

export default app;
